import React from "react";
import { Popover, Typography, Box, styled } from "@mui/material";

// custom arrow
const Arrow = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: "50%",
  transform: "translate(-50%, -100%)",
  width: 20,
  height: 10,
  backgroundColor: "#EFF0FF",
  "&::before": {
    content: '""',
    position: "absolute",
    width: 0,
    height: 0,
    borderLeft: "10px solid transparent",
    borderRight: "10px solid transparent",
    borderBottom: `10px solid ${theme.palette.primary.light}`,
  },
}));

export default function HelpPopup({ open }) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "calc(40px + 10px)", // 40px height of entity select button
        left: "-50px",
        display: open ? "flex" : "none",
        minWidth: "250px",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: -8,
          left: "50%",
          transform: "translateX(-50%) rotate(45deg)",
          width: 16,
          height: 16,
          bgcolor: "#EFF0FF",
          borderRadius: "2px",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          bgcolor: "#EFF0FF",
          p: 1.5,
          borderRadius: "8px",
          boxShadow: "0px 8px 16px -2px rgba(27, 33, 44, 0.12)",
        }}
      >
        <Typography
          variant="fw600s12c8D8D8D"
          sx={{ color: "#4D44D8", lineHeight: "16px" }}
        >
          Get Started
        </Typography>
        <Typography
          variant="fw400s12c686868"
          sx={{ color: "#4D44D8", lineHeight: "16px" }}
        >
          Select the entity for which you want to create custom comparison
          charts
        </Typography>
      </Box>
    </Box>
  );
}
